import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import authService from '../../api/auth/authService';
import { logout } from './authenticationSlice';

interface ModulePrivilege {
  r_id: number;
  key_value: number;
  is_main_menu: number;
  ml_id: number;
  module_name: string;
  module_message_id: number;
  mpl_id: number;
  module_detail_name: string | null;
  pl_id: number;
  og_id: number;
  link_object_id: number;
  object_name: string | null;
  line_no: number;
  descriptions: string;
  ufm_id: number;
  background_color: string | null;
  message_id: number;
  web_url: string;
}

interface GetUserModulePrivilegesState {
  data: ModulePrivilege[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: GetUserModulePrivilegesState = {
  data: null,
  loading: false,
  error: null,
};

export const getUserModulePrivileges = createAsyncThunk<ModulePrivilege[]>(
  'auth/getUserModulePrivileges',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await authService.getUserModulePriviliges();
      return response.data;
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || 'Unexpected error';
      
      // Eğer authorization hatası varsa otomatik logout yap
      if (error?.response?.status === 401 || 
          error?.response?.status === 403 || 
          errorMessage.includes('token') ||
          errorMessage.includes('Unauthorized') ||
          errorMessage === 'Unexpected error') {
                dispatch(logout());
        
        // URL'yi temizle
        if (window.history?.pushState) {
          window.history.pushState({}, '', '/');
        }
      }
      
      return rejectWithValue(errorMessage);
    }
  }
);

const userMenuSlice = createSlice({
  name: 'userMenu',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserModulePrivileges.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.data = null;
      })
      .addCase(getUserModulePrivileges.fulfilled, (state, action: PayloadAction<ModulePrivilege[]>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getUserModulePrivileges.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || 'Failed to fetch privileges';
        state.data = null;
      });
  },
});

export default userMenuSlice.reducer;
